import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactDatePicker from "react-datepicker";
import { twMerge } from "tailwind-merge";
import { useMediaQuery } from "../../../utils/useMediaQuery";
import Input from "./Input";

const getDate = (value) => {
  if (!value) return null;

  const date = new Date(value);
  if (isNaN(date)) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const stickDateTimezone = (value) => {
  if (!value) return;

  if (typeof value === "object") {
    if (isNaN(value)) return;
    return value;
  }

  const date = new Date(value.split("T")[0] + "T00:00:00");
  if (isNaN(date)) return;

  return date;
};

export default function DatePickerInput({
  id,
  classNames,
  selected,
  label,
  dark,
  disabled,
  isRequired,
  autoFocus = false,
}) {
  const isMobile = useMediaQuery("md", "down");
  const [date, setDate] = useState(
    selected ? stickDateTimezone(selected) : undefined
  );

  const {
    control,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    setDate(selected ? stickDateTimezone(selected) : undefined);
  }, [selected]);

  return (
    <div className="[&_.react-datepicker-popper]:z-10">
      {label && <label htmlFor={id}>{label}</label>}
      <Controller
        control={control}
        name={id}
        defaultValue={selected}
        rules={{
          required: isRequired
            ? typeof isRequired === "string"
              ? isRequired
              : "This field is required"
            : false,
        }}
        render={({ field }) =>
          isMobile ? (
            <Input
              id={id}
              type="date"
              inputClassNames={twMerge(
                "border border-gray-200 px-2 py-1.5 rounded w-full bg-white",
                dark && "bg-transparent",
                errors[id] && "border-red-500",
                classNames
              )}
              value={field.value || ""}
              onChange={(e) => field.onChange(e.target.value)}
              autoFocus={autoFocus}
              disabled={disabled}
              placeholder="00/00/0000"
            />
          ) : (
            <ReactDatePicker
              id={id}
              autoFocus={autoFocus}
              disabled={disabled}
              className={twMerge(
                "border border-gray-200 px-2 py-1.5 rounded w-full",
                dark && "bg-transparent",
                errors[id] && "border-red-500",
                classNames
              )}
              selected={date}
              onChange={(date) => {
                setDate(date);
                field.onChange(getDate(date));
              }}
              placeholderText="00/00/0000"
            />
          )
        }
      />

      {errors[id] && (
        <p className="absolute text-red-500">{errors[id]?.message}</p>
      )}
    </div>
  );
}
